/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelAuditLogTx.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/audit-log-tx";

export class AutogenModelAuditLogTx<RowType extends ModelRow> extends Endpoint<RowType, RowAuditLogTxFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowAuditLogTx extends ModelRow<RowAuditLogTxFields> {
	constructor(values?: Partial<RowAuditLogTxFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowAuditLogTxFields {
	application_id: number;
	change_date_time: Date;
	change_date_time_utc: Date;
	changed_values: string;
	company_id: string;
	id: string;
	primary_key_crc: number;
	primary_key_values: string;
	sql_statement: string;
	table_name: string;
	transaction_id: number;
	user_id: string;
}

